import wixLocation from 'wix-location';
import wixWindow from 'wix-window';
import { fireBIEvent } from 'public/bi-events.js';

$w.onReady(function () {
    changeSlide();
    fireBiEventsForCTAs();
});

function changeSlide() {
    $w("#arrowPrev1").onClick((event) => {
        $w("#fullWidthSlides").previous()
    });
    $w("#arrowPrev2").onClick((event) => {
        $w("#fullWidthSlides").previous()
    });
    $w("#arrowPrev3").onClick((event) => {
        $w("#fullWidthSlides").previous()
    });
    $w("#arrowNext1").onClick((event) => {
        $w("#fullWidthSlides").next()
    });
    $w("#arrowNext2").onClick((event) => {
        $w("#fullWidthSlides").next()
    });
    $w("#arrowNext3").onClick((event) => {
        $w("#fullWidthSlides").next()
    });
}

const fireBiEventsForCTAs = () => {

    const expr = wixWindow.formFactor;
    switch (expr) {
    case 'Mobile': {
        const mobileCTAs = [
            { container: '#mobileBox1', button: '#mobileButton3', additional_info: 'top fold', topic: 'fb ads lp- mobile', button_name: $w('#mobileButton3').label },
           
            { container: '#box8', button: '#mobileButton2', additional_info: 'bottom fold', topic: 'fb ads lp- mobile', button_name: $w('#mobileButton2').label },
        ]
        mobileCTAs.forEach((element) => {
            const { container, button, additional_info, topic, button_name } = element
            $w(container).onClick(() => {
                const biFields = {
                    button_name,
                    targetUrl: $w(button).link,
                    url: wixLocation.url,
                    is_valid: true,
                    topic,
                    additional_info,
                }
                fireBIEvent(19, 703, biFields);

            })
        });
        $w('#box2').onClick(() => {
            const biFields = {
                buttonName: $w('#mobileButton1').label,
                videoUrl: $w('#mobileButton1').link,
                pageUrl: wixLocation.url,
                topic: 'fb ads lp- mobile',
                additionalInfo: 'second fold',
            }
            fireBIEvent('fb-ads-lp', 125101, biFields);
        });
    }
    break;
    case 'Desktop': {

        const desktopCTAs = [
            { container: '#box9', button: '#button71', additional_info: 'top fold', topic: 'fb ads lp- desktop', button_name: $w('#button71').label },
            { container: '#box2', button: '#button68', additional_info: 'second fold', topic: 'fb ads lp- desktop', button_name: $w('#button68').label },
            { container: '#box4', button: '#button143', additional_info: 'third fold', topic: 'fb ads lp- desktop', button_name: 'Get Started left' },
            { container: '#box5', button: '#button144', additional_info: 'third fold', topic: 'fb ads lp- desktop', button_name: 'Get Started middle' },
            { container: '#box6', button: '#button145', additional_info: 'third fold', topic: 'fb ads lp- desktop', button_name: 'Get Started right' },
            { container: '#box7', button: '#button149', additional_info: 'fourth fold', topic: 'fb ads lp- desktop', button_name: $w('#button149').label },
            { container: '#box8', button: '#button150', additional_info: 'bottom fold', topic: 'fb ads lp- desktop', button_name: $w('#button150').label },
        ];

        desktopCTAs.forEach((element) => {
            const { container, button, additional_info, topic, button_name } = element
            $w(container).onClick(() => {
                const biFields = {
                    button_name,
                    targetUrl: $w(button).link,
                    url: wixLocation.url,
                    is_valid: true,
                    topic,
                    additional_info,
                }
                fireBIEvent(19, 703, biFields);

            })
        });

        //video button event id: 125101
        $w('#box3').onClick(() => {
            const biFields = {
                buttonName: $w('#button157').label,
                videoUrl: $w('#button157').link,
                pageUrl: wixLocation.url,
                topic: 'fb ads lp- desktop',
                additionalInfo: 'second fold',
            }
            fireBIEvent('fb-ads-lp', 125101, biFields);
        });
    }
    break;
    }

}